import { React, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { AdminEdit } from "..";
import CloseIcon from "@mui/icons-material/Close";
import ReactPaginate from "react-paginate";
import "../../styles/Overflow.css";

function AdminTable(props) {
  const { admins, updateTable, setUpdateTable } = props;

  const handleDelete = (adminId) => {
    if (admins.length === 1) {
      alert("Cannot delete last admin.");
      return;
    }
    const body = new FormData();
    body.append("adminId", adminId);
    axios.post("/admin/deleteAdmin", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setUpdateTable(!updateTable);
      }
    });
  };

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  const items = admins.map((admin, index) => (
    <div key={index}>
      <div className="AdminRow-container flex rounded-md border-2 border-brand-tertiary drop-shadow-2xl mb-2">
        <div className="AdminRow-name text-xl flex justify-center font-brand-primary w-4/12 border-r-2 py-2">
        <p className="overFlowBigger">{admin.firstName} {admin.lastName}</p>
        </div>
        <div className="AdminRow-username text-xl flex justify-center font-brand-primary w-3/12 border-r-2 py-2">
          <p className="overFlowBigger">{admin.pid}</p>
        </div>
        <div className="AdminRow-email text-xl flex justify-center font-brand-primary w-3/12 border-r-2 py-2">
        <p className="overFlowBigger">{admin.email}</p>
        </div>
        <div className="AdminRow-editDelete text-xl flex justify-center w-2/12 py-2">
          <AdminEdit updateTable={updateTable} setUpdateTable={setUpdateTable} admin={admin} />
          <button className="AdminRow-deleteButton flex" onClick={() => handleDelete(admin.adminId)}>
            <CloseIcon fontSize="large" className="fill-brand-primary" />
          </button>
        </div>
      </div>
    </div>
  ));

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const itemsPerPage = 5;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  if (admins.length === 0) {
    return <div className="AdminTable">No admins found.</div>;
  } else {
    return (
      <div className="AdminTable bg-white p-2 rounded-xl w-full">
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          className="AdminTable-pagination flex w-full justify-between mb-6 mt-4 [&>li>a]:py-4 [&>li>a]:px-6 [&>li>a]:border [&>li>a]:rounded-lg [&>li.selected>a]:border-brand-primary"
        />
        <div className="AdminTable-container flex rounded-md border-2 border-black drop-shadow-2xl mb-1">
          <div className="AdminTable-name text-xl flex justify-center font-brand-primary w-4/12 border-black border-r-2 py-2">
            Name
          </div>
          <div className="AdminTable-username text-xl flex justify-center font-brand-primary w-3/12 border-black border-r-2 py-2">
            Pid
          </div>
          <div className="AdminTable-email text-xl flex justify-center font-brand-primary w-3/12 border-black border-r-2 py-2">
            Email
          </div>
          <div className="AdminTable-editDelete text-xl flex justify-center w-2/12 py-2">
            <div className="flex mr-4">
              Edit
            </div>
            /
            <div className="flex ml-4">
              Delete
            </div>
          </div>
        </div>
        {currentItems}
      </div>
    );
  }
}

AdminTable.propTypes = {
  admins: PropTypes.arrayOf({
    adminId: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    pid: PropTypes.string,
    email: PropTypes.string,
  }),
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
};

AdminTable.defaultProps = {
  admins: [],
  updateTable: false,
  setUpdateTable: () => { },
};

export default AdminTable;
